module.exports = __webpack_public_path__ + "static/media/char_parallax_1.1da9d009.png";